import React from "react"
import {Box} from "@mui/material"

import type {UnidentifiedThreadMessage} from "../types"

import {MessageRow} from "./MessageRow"

function Thread({
	messages,
	threadSubject,
	senderAddress,
	channel,
	conversationID,
}: {
	messages: UnidentifiedThreadMessage[]
	threadSubject: string
	senderAddress: string
	channel: string
	conversationID: string
}) {
	return (
		<Box component="ul" display="flex" flexDirection="column" gap={3} m={0} p={0}>
			{messages.map((message) => (
				<MessageRow
					key={`${message.Direction}:${message.ProviderMessageID}:${message.OccurredAt}`}
					message={message}
					threadSubject={threadSubject}
					senderAddress={senderAddress}
					channel={channel}
					conversationID={conversationID}
				/>
			))}
		</Box>
	)
}

export {Thread}
